import { createContext } from 'react';
export const ToastPresentationContext = createContext(false);
